import { instance } from '@/services/avik-api-gateway'
import { StatusActiveEvent } from '@/types/status-active-event'
import { AxiosResponse } from 'axios'

export function getActiveEvents(): Promise<AxiosResponse<StatusActiveEvent>> {
  return instance.get(`/status/active-event`)
}
